module.exports = __webpack_public_path__ + "static/media/settings.75fac13d.png";